type ToggleSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
  className?: string;
};

export function ToggleSwitch({
  checked,
  onChange,
  label,
  description,
  disabled = false,
  className = '',
}: ToggleSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={[
        'group flex w-full items-center gap-3 rounded-md border border-border-default/[0.12] px-3 py-2 text-left transition',
        checked ? 'bg-accent/10 border-accent/35' : 'bg-surface-2/40 hover:bg-surface-2',
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        className,
      ].join(' ')}
      onClick={() => onChange(!checked)}
    >
      <span
        className={[
          'relative inline-flex h-5 w-9 shrink-0 rounded-full transition',
          checked ? 'bg-accent' : 'bg-border-default/40',
        ].join(' ')}
        aria-hidden="true"
      >
        <span
          className={[
            'absolute top-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform',
            checked ? 'translate-x-4' : 'translate-x-0.5',
          ].join(' ')}
        />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-label font-medium text-text-primary">{label}</span>
        {description ? (
          <span className="mt-0.5 block text-caption text-text-tertiary">
            {description}
          </span>
        ) : null}
      </span>
      <span className={checked ? 'pill-success shrink-0' : 'pill-neutral shrink-0'}>
        {checked ? 'Вкл' : 'Выкл'}
      </span>
    </button>
  );
}
